import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PageMetaTitle from '../components/PageMetaTitle'
import DashLayout from './partials/DashLayout'

import notFound from '../assets/503/frame.png'
import { mainColors } from '../constants/constants'

const MainSection = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 15px;
  text-align: center;

  h2 {
    font-size: 24px;
    line-height: 28px;
    color: #AAB2C8;
    margin-top: 30px;

    span {
      color: ${mainColors.darkBlue};
      padding-right: 5px;
    }
  }
`

const Error503 = () => {
  const { t } = useTranslation()
  const isAuth = useSelector(state => state.auth.isAuth)

  const body = (
    <>
      <img className='img-fluid' src={notFound} alt='Not found' />
      <h2><span>{t('503.oops')}</span>{t('503.error')}</h2>
    </>
  )

  if (isAuth) {
    return (
      <DashLayout>
        <PageMetaTitle title='503' />
        <MainSection>
          {body}
        </MainSection>
      </DashLayout>
    )
  }

  return (
    <MainSection>
      {body}
    </MainSection>
  )
}

export default Error503

